import styled from "styled-components";

export const Page = styled.div`
  padding: 16px;
  padding-bottom: 180px;
  max-width: 560px;
  margin: 0 auto;

  @media (min-width: 1024px) {
    max-width: 1320px;
    padding: 24px 32px;
  }
`;

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-dark, #1D1D1F);
  margin: 24px 0;

  @media (min-width: 1024px) {
    margin: 24px 0 16px;
  }
`;

export const SectionLabel = styled.h2`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-dark, #1D1D1F);
  margin: 24px 0 16px;
`;

export const Divider = styled.div`
  height: 1px;
  background: #D9D9D9;
  margin: 24px 0;
`;

export const CheckoutLayout = styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 32px;
    align-items: start;
    margin-top: 8px;

    .co-summary {
      position: sticky;
      top: 100px;
      background: #F5F5F7;
      border-radius: 8px;
      padding: 20px 16px;
    }
  }
`;

export const FixedFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: white;
  border-top: 1px solid #d9d9d9;
  padding: 16px;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const InsufficientPointsWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  margin: 16px 0;
  border-radius: 8px;
  background: #FFF3CD;
  border: 1px solid #FFECB5;
  color: #664D03;
  font-size: 14px;
  line-height: 1.5;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #997404;
  }

  strong {
    font-weight: 600;
  }
`;
